export default function Button(props) {	
	
	return (
    	<button open={props.open} onClick={props.onClick} className="rounded-full bg-gray2 px-3 sm:px-4 py-1 mx-2 hover:bg-gray3 hover:text-white open:bg-green">{props.children}</button>
	);
}